import React from "react";

const AuthorImg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 250 250">
      <g fill="none">
        <path fill="#D2D1D1" d="M0 0h250v250H0z" />
        <path
          d="M42.917 251v-20.167c0-44.413 36.003-80.416 80.416-80.416H125c44.413 0 80.417 36.003 80.417 80.416V251h-162.5z"
          fill="#A6A6A6"
        />
        <path
          d="M124.583 164.167c24.375 0 48.75-21.826 48.75-48.75s-21.826-48.75-48.75-48.75-48.75 21.826-48.75 48.75 24.375 48.75 48.75 48.75z"
          stroke="#D2D1D1"
          fill="#A6A6A6"
        />
      </g>
    </svg>
  );
};

export default AuthorImg;
